import { graphql } from 'services/api';
import { COMPONENTS_FROM_PAGE } from 'graphqlQueriesAndMutations/queries';
import {
	REMOVE_COMPONENT,
	UPDATE_MANY_COMPONENTS_POSITION
} from 'graphqlQueriesAndMutations/mutations';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';

interface GetcomponentsBySlugProps {
	isSuccess: boolean;
	data: ItemDynamicPageInPhone[] | null;
}

export async function getcomponentsBySlug(slug: string, handleNotify: any) {
	const resp: GetcomponentsBySlugProps = { isSuccess: false, data: null };
	try {
		const { data } = await graphql.mutate({
			mutation: COMPONENTS_FROM_PAGE,
			variables: { languageSlug: 'en', pageSlug: slug, sc: '1' }
		});
		if (data?.componentsFromPage) {
			const newList: ItemDynamicPageInPhone[] = [];

			if (data?.componentsFromPage.length > 0) {
				data?.componentsFromPage.forEach((item: ItemDynamicPageInPhone) => {
					item.isEdit = false;
					newList.push(item);
				});
			}

			resp.data = newList;
			resp.isSuccess = true;
		}
	} catch {
		resp.data = null;
		resp.isSuccess = false;
		handleNotify('Ocorreu algum erro aao buscar os itens da página', 'error');
	}

	return resp;
}

export async function deleteModuleFromBack(
	idModuleToEdit: string,
	pageSelectedSlug: string,
	handleNotify: any
) {
	const resp = { isSuccess: false };
	await graphql
		.mutate({
			mutation: REMOVE_COMPONENT,
			variables: {
				id: idModuleToEdit,
				languageSlug: 'en',
				pageSlug: pageSelectedSlug
			}
		})
		.then(() => {
			resp.isSuccess = true;
			handleNotify('Módulo deletado com sucesso!', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			handleNotify(
				error?.message || 'Ocorreu algum erro para deletar o módulo',
				'error'
			);
		});

	return resp;
}

export async function refreshPositionItens(
	modulesToSave: ItemDynamicPageInPhone[],
	slug: string,
	handleNotify: any
) {
	const newList = modulesToSave.map((item, i) => ({
		component_id: item.id,
		language_slug: 'en',
		page_slug: slug,
		position: i
	}));

	const resp = { isSuccess: false };
	await graphql
		.mutate({
			mutation: UPDATE_MANY_COMPONENTS_POSITION,
			variables: {
				updateManyComponentsPosition: newList
			}
		})
		.then((res) => {
			if (res.data) {
				resp.isSuccess = true;
				handleNotify('Lista de módulos atualizada', 'success');
			}
		})
		.catch((error) => {
			resp.isSuccess = false;
			handleNotify(
				error?.message ||
					'Algum erro aconteceu ao editar o posionamento dos módulos. Tente novamente.',
				'error'
			);
		});

	return resp;
}
